import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import { splunkApi1 } from '../../utils/Api'
import axios from 'axios';
import { Button } from '@mui/material';
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);


function LoginDashboard() {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('user') || '{}');
    } catch {
      return {};
    }
  });


  return (
    <Box sx={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a2240 0%, #1e3a5f 100%)',
      backgroundSize: 'cover',
      color: 'white',
      py: 6,
      px: { xs: 1, sm: 4 },
      position: 'relative'
    }}>
      
      
      {/* User name at top right */}
      {user && user.name && (
        <Typography sx={{ position: 'absolute', top: 24, right: 32, fontWeight: 700, fontSize: 18, color: '#e0f7fa', letterSpacing: 0.5 }}>
          Welcome, {user.name}
        </Typography>
      )}
      <Typography variant="h3" sx={{ mb: 3, fontWeight: 600, letterSpacing: -1, background: 'linear-gradient(90deg, #00b4a0 0%, #1e90ff 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
        Dashboard
      </Typography>
      <Grid container spacing={4} alignItems="center" sx={{ mb: 4 }}>
        <Grid item xs={12} md={12} p={4}>
          <Card sx={{ background: 'rgba(10,34,64,0.92)', borderRadius: 3, boxShadow: 3, minHeight: 220 }}>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: 'white' }}>Confluent</Typography>
              <Divider sx={{ mb: 2, borderColor: 'rgba(255,255,255,0.1)' }} /> 
              <Typography variant="body2" sx={{ color: '#b0bec5' }}>Username : elastic-tech1</Typography>   
              <Typography variant="body2" sx={{ color: '#b0bec5' }}>Password: iValue2025$</Typography>      
              <Divider sx={{ mb: 2, borderColor: 'rgba(255,255,255,0.1)' }} />  
              <Button
                variant="contained"
                sx={{
                  mt: 2,
                  width: '100%',
                  background: 'linear-gradient(90deg, #00b4a0 0%, #1e90ff 100%)',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 16,
                  borderRadius: 2,
                  boxShadow: '0 2px 8px 0 rgba(30,144,255,0.15)',
                  textTransform: 'none',
                  letterSpacing: 0.5,            
                  '&:hover': {
                    background: 'linear-gradient(90deg, #1e90ff 0%, #00b4a0 100%)',
                    boxShadow: '0 4px 16px 0 rgba(0,180,160,0.18)'
                  }
                }}
                onClick={() => window.open('https://remote.ivalueinfosol.net/guacamole/#/client/MzUAYwBteXNxbA', '_blank')}
              >
                Login to Confluent
              </Button>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={6} md={6} p={4}>
          <Card sx={{ background: 'rgba(10,34,64,0.92)', borderRadius: 3, boxShadow: 3, minHeight: 220 }}>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: 'white' }}>Splunk</Typography>
              <Divider sx={{ mb: 2, borderColor: 'rgba(255,255,255,0.1)' }} /> 
              <Typography variant="body2" sx={{ color: '#b0bec5' }}>Username : confluent1</Typography>   
              <Typography variant="body2" sx={{ color: '#b0bec5' }}>Password: iValue2025$</Typography>      
              <Divider sx={{ mb: 2, borderColor: 'rgba(255,255,255,0.1)' }} />  
              <Typography variant="body2" sx={{ color: '#b0bec5' }}>Splunk Web Credential</Typography> 
              <Typography variant="body2" sx={{ color: '#b0bec5' }}>Username : admin</Typography>   
              <Typography variant="body2" sx={{ color: '#b0bec5' }}>Password: Splunk@1234</Typography>      
              <Divider sx={{ mb: 2, borderColor: 'rgba(255,255,255,0.1)' }} />  
              <Button
                variant="contained"
                sx={{
                  mt: 2,
                  width: '100%',
                  background: 'linear-gradient(90deg, #00b4a0 0%, #1e90ff 100%)',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 16,
                  borderRadius: 2,
                  boxShadow: '0 2px 8px 0 rgba(30,144,255,0.15)',
                  textTransform: 'none',
                  letterSpacing: 0.5,            
                  '&:hover': {
                    background: 'linear-gradient(90deg, #1e90ff 0%, #00b4a0 100%)',
                    boxShadow: '0 4px 16px 0 rgba(0,180,160,0.18)'
                  }
                }}
                onClick={() => window.open('https://remote.ivalueinfosol.net/guacamole/#/client/MzIAYwBteXNxbA', '_blank')}
              >
                Login to Splunk
              </Button>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={6} md={6} p={4}>
            <Card sx={{ background: 'rgba(10,34,64,0.92)', borderRadius: 3, boxShadow: 3, minHeight: 220 }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: 'white' }}>Elastic</Typography>
                <Divider sx={{ mb: 2, borderColor: 'rgba(255,255,255,0.1)' }} />    
              <Typography variant="body2" sx={{ color: '#b0bec5' }}>Username : elastic3</Typography>   
              <Typography variant="body2" sx={{ color: '#b0bec5' }}>Password: XdQ0g3M</Typography>      
              <Divider sx={{ mb: 2, borderColor: 'rgba(255,255,255,0.1)' }} />  
              <Typography variant="body2" sx={{ color: '#b0bec5' }}>Elastic Web Credential</Typography> 
              <Typography variant="body2" sx={{ color: '#b0bec5' }}>Username : elastic</Typography>   
              <Typography variant="body2" sx={{ color: '#b0bec5' }}>Password: admin@123</Typography>      
              <Divider sx={{ mb: 2, borderColor: 'rgba(255,255,255,0.1)' }} />  
              <Button
                variant="contained"
                sx={{
                  mt: 2,
                  width: '100%',
                  background: 'linear-gradient(90deg, #00b4a0 0%, #1e90ff 100%)',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 16,
                  borderRadius: 2,
                  boxShadow: '0 2px 8px 0 rgba(30,144,255,0.15)',
                  textTransform: 'none',
                  letterSpacing: 0.5,            
                  '&:hover': {
                    background: 'linear-gradient(90deg, #1e90ff 0%, #00b4a0 100%)',
                    boxShadow: '0 4px 16px 0 rgba(0,180,160,0.18)'
                  }
                }}
                onClick={() => window.open('https://remote.ivalueinfosol.net/guacamole/#/client/NTcAYwBteXNxbA', '_blank')}
              >
                Login to Elastic
              </Button>        
              </CardContent>
            </Card>
        </Grid>
        <Grid item xs={6} md={6} p={4}>
            <Card sx={{ background: 'rgba(10,34,64,0.92)', borderRadius: 3, boxShadow: 3, minHeight: 220 }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: 'white' }}>Google Chronicle</Typography>
                <Divider sx={{ mb: 2, borderColor: 'rgba(255,255,255,0.1)' }} />              
              </CardContent>
            </Card>
        </Grid>        
        <Grid item xs={6} md={6} p={4}>
            <Card sx={{ background: 'rgba(10,34,64,0.92)', borderRadius: 3, boxShadow: 3, minHeight: 220 }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: 'white' }}>ArcSight</Typography>
                <Divider sx={{ mb: 2, borderColor: 'rgba(255,255,255,0.1)' }} />    
              <Typography variant="body2" sx={{ color: '#b0bec5' }}>Username : arcsight</Typography>   
              <Typography variant="body2" sx={{ color: '#b0bec5' }}>Password: P@ssw0rd</Typography>      
              <Divider sx={{ mb: 2, borderColor: 'rgba(255,255,255,0.1)' }} />  
              <Button
                variant="contained"
                sx={{
                  mt: 2,
                  width: '100%',
                  background: 'linear-gradient(90deg, #00b4a0 0%, #1e90ff 100%)',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 16,
                  borderRadius: 2,
                  boxShadow: '0 2px 8px 0 rgba(30,144,255,0.15)',
                  textTransform: 'none',
                  letterSpacing: 0.5,            
                  '&:hover': {
                    background: 'linear-gradient(90deg, #1e90ff 0%, #00b4a0 100%)',
                    boxShadow: '0 4px 16px 0 rgba(0,180,160,0.18)'
                  }
                }}
                onClick={() => window.open('https://remote.ivalueinfosol.net/guacamole/#/client/OABjAG15c3Fs', '_blank')}
              >
                Login to ArkSight
              </Button>        
              </CardContent>
            </Card>
        </Grid>
      </Grid>
      
    </Box>
  );
}

export default LoginDashboard;
